import { render, staticRenderFns } from "./shelves.vue?vue&type=template&id=b8036c0e&scoped=true"
import script from "./shelves.vue?vue&type=script&lang=ts"
export * from "./shelves.vue?vue&type=script&lang=ts"
import style0 from "./shelves.vue?vue&type=style&index=0&id=b8036c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8036c0e",
  null
  
)

export default component.exports